import { PayrollCheckItemDto } from '@clh/api-client';

export type ShiftOvertime = { overtimeHours: number; overtimeCents: number };

export function overtimeOnCheck(checkItems: PayrollCheckItemDto[]) {
    const shiftIdByTime = new Map(
        checkItems
            .filter((item) => item.shiftId && item.time)
            .map((item) => [item.time!.getTime(), item.shiftId!])
    );
    const totals = new Map<string, { minutes: number; cents: number }>();

    for (const item of checkItems) {
        if (!item.overtimeMinutes) continue;
        const shiftId =
            item.shiftId ?? shiftIdByTime.get(item.time?.getTime() ?? NaN);
        if (!shiftId) continue;

        const total = totals.get(shiftId) ?? { minutes: 0, cents: 0 };
        total.minutes += item.overtimeMinutes;
        total.cents += Math.round(
            (item.overtimeMinutes / 60) * (item.overtimeWage ?? 0)
        );
        totals.set(shiftId, total);
    }

    return new Map<string, ShiftOvertime>(
        [...totals].map(([shiftId, total]) => [
            shiftId,
            {
                overtimeHours: Math.round((total.minutes / 60) * 100) / 100,
                overtimeCents: total.cents,
            },
        ])
    );
}
